import { render, staticRenderFns } from "./AwardsNavItem.vue?vue&type=template&id=9a156492&"
import script from "./AwardsNavItem.vue?vue&type=script&lang=js&"
export * from "./AwardsNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports